import React, { useState } from 'react';
import RichTextEditor from '../RichTextEditor';
import './PlayerUpdateForms.css';

/**
 * CoachReplyForm - Coach's reply form for player updates
 * Now uses RichTextEditor for formatted replies
 */
const CoachReplyForm = ({ onSubmit, onCancel }) => {
  const [replyText, setReplyText] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  // Extract plain text from HTML for validation
  const getPlainText = (html) => {
    const temp = document.createElement('div');
    temp.innerHTML = html;
    return temp.innerText || '';
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    const plainText = getPlainText(replyText);
    if (!plainText.trim()) {
      setError('Reply cannot be empty');
      return;
    }

    setSubmitting(true);
    try {
      await onSubmit(replyText);
    } catch (err) {
      setError(err.message || 'Failed to send reply');
      setSubmitting(false);
    }
  };

  return (
    <form className="coach-reply-form" onSubmit={handleSubmit}>
      {error && (
        <div className="form-error">
          ⚠️ {error}
        </div>
      )}

      <div className="form-group">
        <label htmlFor="coach-reply">Your Reply</label>
        <RichTextEditor
          value={replyText}
          onChange={setReplyText}
          maxCharacters={1000}
          placeholder="Type your response to the player..."
          disabled={submitting}
        />
      </div>

      <div className="form-actions">
        <button
          type="button"
          className="btn-cancel"
          onClick={onCancel}
          disabled={submitting}
        >
          Cancel
        </button>
        <button
          type="submit"
          className="btn-submit"
          disabled={submitting || !replyText.trim()}
        >
          {submitting ? 'Sending...' : 'Send Reply'}
        </button>
      </div>
    </form>
  );
};

export default CoachReplyForm;
